import { isNull } from './isNull';

export function isObject(value) {
  return (!isNull(value) && !Array.isArray(value) && typeof value === 'object');
}
